import {omit} from "lodash";
import {postMessage} from "@atg-mobileapp-shared/post-message";
import type {TrackingEvent} from "@atg-shared/analytics-types";

// Prevent "TypeError: Converting circular structure to JSON"
function safeStringify(object: {type: string; data: Record<string, unknown>}) {
    const seen = new WeakSet();

    return JSON.stringify(object, (_key, value) => {
        if (typeof value === "object" && value !== null) {
            if (seen.has(value)) {
                return "[Circular]";
            }
            seen.add(value);
        }
        return value;
    });
}

// post message to react native host
const postEvent = (data: Record<string, unknown>) => {
    postMessage(
        safeStringify({
            type: "Analytics",
            data,
        }),
    );
};

export const trackNavigate = (path: string) => postEvent({event: "sport-navigate", path});

export const trackBetslip = (target: string, interaction: string, match: string) =>
    postEvent({event: "sport-betslip-interaction", target, interaction, match});

/**
 * Method used for tracking events in the webview.
 * Since we have method called trackEvent in shared lib, naming this trackWebViewEvent to avoid confusion
 * Our analytics is done via atg.se, therefore we postMessage to react native, which then invokes a special method in the WebView in DepositModal - where the event is pushed to the dataLayer, so that GTM can pick it up.
 */
export const trackWebViewEvent = (eventData: TrackingEvent) => {
    // add event origin, so that we track correctly in Optimizely
    postEvent({...eventData, _eventOrigin: "AppWebView"});
};

type EventType = {
    event: string;
    kambi: {
        ecommerce?: unknown;
    } & Record<string, unknown>;
    "gtm.uniqueEventId": number;
} & Record<string, unknown>;

export const trackPurchase = (event: EventType) => {
    const eventToPost = {...omit(event, "kambi"), ...event.kambi};
    postEvent(eventToPost);
};

export const trackDataLayer = (event: EventType) => {
    if (event.kambi.ecommerce) {
        trackPurchase(event);
        return;
    }

    postEvent(event);
};
